export default __webpack_public_path__ + "static/vespucci_canals_counterfeit-1fca99914bbde5ee2a7c2bb7e037a6a4.png";